// Module
var code = "<script>let DashboardOverviewCtrl</script> <div ng-repeat=\"item in DashboardOverviewCtrl.serviceItemList track by item.id\"> <molecule-panel-managed-machine-dashboard machine-item=\"item\"> </molecule-panel-managed-machine-dashboard> </div> ";
// Exports
module.exports = code;